export default {
  showTimezones: false,
  customerTime: true,
  utcTime: false,
  lettuceboxTime: false,
  relativeTime: false,
  getEnabledTimeFormats: function () {
    const enabledTimes = []

    if (this.customerTime) { enabledTimes.push('customerTime') }
    if (this.utcTime) { enabledTimes.push('utcTime') }
    if (this.lettuceboxTime) { enabledTimes.push('lettuceboxTime') }
    if (this.relativeTime) { enabledTimes.push('relativeTime') }

    return enabledTimes
  }
}
